module.exports = __webpack_public_path__ + "img/781.20a00006.jpg";